var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-virtual-scroll',{ref:"parentContainer",class:['d-flex', 'flex-column', 'pa-2'],attrs:{"items":_vm.shots,"item-height":"140","bench":_vm.shotsLength},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('ShotCard',{ref:("childContainer-" + (item.id)),attrs:{"shot":item},on:{"childHighlighted":_vm.scrollToHighlightedChild}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }